import * as types from "./types.js"
import * as api from "./api.js"


function getLicensesRequest() {
    return {
        type: types.GET_LICENSES_REQUEST
    }
}

function getLicensesReceived(licenses) {
    return {
        type: types.GET_LICENSES_RECEIVED,
        payload: licenses
    }
}

function getLicensesError(e) {
    return {
        type: types.GET_LICENSES_ERROR,
        payload: e,
        error: true
    }
}

export function getLicenses(personid) {
    return dispatch => {
        dispatch(getLicensesRequest())
        return api.getLicenses(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getLicensesError(res.statusText))
            } else {
                return res.json()
                .then(licenses => {
                    dispatch(getLicensesReceived(licenses))
                })
            }
        })
    }
}


function postLicenseRequest() {
    return {
        type: types.POST_LICENSE_REQUEST
    }
}

function postLicenseReceived(stats) {
    return {
        type: types.POST_LICENSE_RECEIVED,
        payload: stats
    }
}

function postLicenseError(e) {
    return {
        type: types.POST_LICENSE_ERROR,
        payload: e,
        error: true
    }
}

export function postLicense(license) {
    return (dispatch) => {
        dispatch(postLicenseRequest())
        return api.postLicense(license)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postLicenseError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postLicenseReceived({
                        id: stats.id,
                        license: license.license,
                        authority: license.authority,
                        valid: license.unlimited === true ? null : license.valid,
                        eplevel: license.eplevel === 0 ? "n/a" : license.eplevel
                    }))
                })
            }
        })
    }
}


function putLicenseRequest() {
    return {
        type: types.PUT_LICENSE_REQUEST
    }
}

function putLicenseReceived(stats) {
    return {
        type: types.PUT_LICENSE_RECEIVED,
        payload: stats
    }
}

function putLicenseError(e) {
    return {
        type: types.PUT_LICENSE_ERROR,
        payload: e,
        error: true
    }
}

export function putLicense(license) {
    return (dispatch) => {
        dispatch(putLicenseRequest())
        return api.putLicense(license)
        .then(res => {
            if (res.status !== 200) {
                dispatch(putLicenseError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(putLicenseReceived({
                        id: license.id,
                        license: license.license,
                        authority: license.authority,
                        valid: license.unlimited === true ? null : license.valid,
                        eplevel: license.eplevel === 0 ? "n/a" : license.eplevel
                    }))
                })
            }
        })
    }
}


function deleteLicenseRequest() {
    return {
        type: types.DELETE_LICENSE_REQUEST
    }
}

function deleteLicenseReceived(id) {
    return {
        type: types.DELETE_LICENSE_RECEIVED,
        payload: id
    }
}

function deleteLicenseError(e) {
    return {
        type: types.DELETE_LICENSE_ERROR,
        payload: e,
        error: true
    }
}

export function deleteLicense(id) {
    return (dispatch) => {
        dispatch(deleteLicenseRequest())
        return api.deleteLicense(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteLicenseError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteLicenseReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/licenses/actions.js
 **/